import BaseModelAPI from '../BaseModelAPI';

export default class ReportSummaryNGList extends BaseModelAPI {

	static entity = 'newreport2018list'
	static entityName = 'reportsummaryng';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
